import {setTimeout} from "timers";
<template>
  <v-flex class="pl-2 pr-2 pb-2">
    <v-layout align-start justify-start row class="mb-4">
      <v-icon color="primary" style="font-size: 50px;">group</v-icon>
      <h2 :style="`color: ${$vuetify.theme.primary}`" class="mt-2">
        {{ $translate("PARTNERS") }}
      </h2>
      <v-spacer></v-spacer>

      <v-btn fab right color="secondary" @click="newItem">
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>

    <v-spacer></v-spacer>
    <v-data-table
      :headers="headers"
      :items="partners"
      class="elevation-1"
      :rows-per-page-items="[10]"
    >
      <template v-slot:items="props">
        <td>{{ props.item.Name }}</td>
        <td>{{ props.item.Email }}</td>
        <td>{{ props.item.Type }}</td>
        <td>
          <v-checkbox
            :input-value="props.item.PlanningContract"
            class="justify-center"
            hide-details
            disabled
          ></v-checkbox>
        </td>
        <td>
          <v-checkbox
            :input-value="props.item.PaymentContract"
            class="justify-center"
            hide-details
            disabled
          ></v-checkbox>
        </td>
        <td>
          <v-chip color="green" text-color="white" v-if="props.item.Active"
            >{{ $translate("ACTIVE") }}
          </v-chip>
          <v-chip color="red" text-color="white" v-else
            >{{ $translate("INACTIVE") }}
          </v-chip>
        </td>
        <td class="justify-center">
          <v-btn
            small
            class="v-btn-tiny mr-2"
            color="primary"
            @click="switchToPartnerAdmin(props.item)"
          >
            <v-icon small>ti-reload</v-icon>
          </v-btn>
          <v-btn
            small
            class="v-btn-tiny mr-2"
            color="primary"
            @click="editItem(props.item)"
          >
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn
            small
            class="v-btn-tiny mr-2"
            color="primary"
            @click="deleteItem(props.item)"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $translate("DELETE_PARTNER_TITLE") }}</span>
        </v-card-title>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                disabled
                v-model="partner.Name"
                :label="$translate('PARTNER_NAME')"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary darken-1"
            round
            @click="dialogDelete = false"
            >{{ $translate("CANCEL") }}</v-btn
          >
          <v-btn
            color="primary darken-1"
            :disabled="deleteDisable"
            :loading="deleteDisable"
            round
            @click="deletePartner"
            >{{ $translate("DELETE") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="partnerDetailsDialog"
      persistent
      no-click-animation
      max-width="1000px"
    >
      <v-container class="grey lighten-5" grid-list-xs>
        <v-layout class="ml-4 mt-2" justify-start align-start row>
          <v-icon color="primary" style="font-size: 50px;">border_color</v-icon>
          <h2 :style="`color: ${$vuetify.theme.primary}`" class="mt-2">
            {{ formTitle }}
          </h2>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-form
              v-model="partnerFormValid"
              lazy-validation
              ref="partnerForm"
            >
              <v-layout>
                <v-flex xs12>
                  <h3>{{ $translate("GENERAL") }}</h3>
                  <v-card class="blockForInputfields">
                    <v-layout row wrap justify-space-around>
                      <v-flex xs5>
                        <h4>{{ $translate("PARTNER_NAME") }}</h4>
                        <v-text-field
                          v-model="partner.Name"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('PARTNER_NAME')"
                          outline
                          required
                          :rules="partnerNameRule"
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{ $translate("PARTNER_DISPLAY_NAME") }}</h4>
                        <v-text-field
                          v-model="partner.DisplayName"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('PARTNER_DISPLAY_NAME')"
                          outline
                          required
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{ $translate("PARTNER_ADDRESS") }}</h4>
                        <v-text-field
                          v-model="partner.Address"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('PARTNER_ADDRESS')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{ $translate("PARTNER_CITY") }}</h4>
                        <v-text-field
                          v-model="partner.City"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('PARTNER_CITY')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{ $translate("PARTNER_POSTAL_CODE") }}</h4>
                        <v-text-field
                          v-model="partner.PostalCode"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('PARTNER_POSTAL_CODE')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{ $translate("PARTNER_EMAIL") }}</h4>
                        <v-text-field
                          v-model="partner.Email"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('PARTNER_EMAIL')"
                          outline
                          required
                          :rules="partnerEmailRule"
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>
                          {{ $translate("ADMINISTRATION_PARTNER_EMAIL") }}
                        </h4>
                        <v-text-field
                          v-model="partner.AdministrationEmail"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('ADMINISTRATION_PARTNER_EMAIL')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>
                          {{ $translate("NO_REPLY_EMAIL") }}
                        </h4>
                        <v-text-field
                          v-model="partner.NoReplyEmailAddress"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('NO_REPLY_EMAIL')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>Partner CoC code (KvK)</h4>
                        <v-text-field
                          v-model.number="partner.COC"
                          rows="1"
                          class="mb-2"
                          label="COC / KVK code"
                          outline
                        />
                      </v-flex>
                      <v-flex
                        xs5
                        v-if="this.$store.getters['auth/userLevel'] == 9"
                      >
                        <h4>{{ $translate("PARTNER_LEVEL") }}</h4>
                        <v-select
                          v-model="partner.PartnerLevel"
                          :items="partnerLevels"
                          item-text="Name"
                          item-value="Level"
                          :label="$translate('PARTNER_LEVEL')"
                          outline
                        />
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <h3>External event platform</h3>
                  <v-card class="blockForInputfields">
                    <v-layout row wrap justify-space-around>
                      <v-layout class="mt-2" row wrap justify-space-around>
                        <v-flex xs5>
                          <h4>Formitable</h4>
                          <v-text-field
                            v-model="
                              partner.ExternalEventBridges.Formitable.ApiKey
                            "
                            rows="1"
                            auto-grow
                            class="mb-2"
                            label="Api key"
                            outline
                            required
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout class="mt-2" row wrap justify-space-around>
                        <v-flex xs5>
                          <v-layout row>
                            <v-flex xs12>
                              <h4>TicketCounter</h4>
                            </v-flex>
                          </v-layout>
                          <v-text-field
                            v-model="
                              partner.ExternalEventBridges.TicketCounter
                                .ClientId
                            "
                            rows="1"
                            auto-grow
                            class="mb-2"
                            label="ClientId"
                            outline
                            required
                          />
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            v-model="
                              partner.ExternalEventBridges.TicketCounter
                                .ClientSecret
                            "
                            rows="1"
                            auto-grow
                            class="mb-2"
                            label="ClientSecret"
                            outline
                            required
                          />
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            v-model="
                              partner.ExternalEventBridges.TicketCounter
                                .Username
                            "
                            rows="1"
                            auto-grow
                            class="mb-2"
                            label="Username"
                            outline
                            required
                          />
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            v-model="
                              partner.ExternalEventBridges.TicketCounter
                                .Password
                            "
                            rows="1"
                            auto-grow
                            class="mb-2"
                            label="Password"
                            outline
                            required
                          />
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            v-model="
                              partner.ExternalEventBridges.TicketCounter
                                .RefreshToken
                            "
                            rows="1"
                            auto-grow
                            class="mb-2"
                            label="RefreshToken"
                            outline
                            required
                          />
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <h3>{{ $translate("COMMUNICATIONS") }}</h3>
                  <v-card class="blockForInputfields">
                    <v-layout row wrap justify-space-around>
                      <v-flex xs5>
                        <v-checkbox
                          v-model="partner.NotifyBooked"
                          label="Visitor booked notifications"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="partner.NotifyArrived"
                          label="Visitor arrival notifications"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <h3>{{ $translate("FINANCIAL") }}</h3>
                  <v-card class="blockForInputfields">
                    <v-layout row wrap justify-space-around>
                      <v-flex xs5>
                        <h4>{{ $translate("PARTNER_IBAN") }}</h4>
                        <v-text-field
                          v-model="partner.IBAN"
                          rows="1"
                          auto-grow
                          class="mb-2"
                          :label="$translate('PARTNER_IBAN')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{ $translate("ACCOUNT_VAT_BTW") }}</h4>
                        <v-text-field
                          v-model.number="partner.VatNumber"
                          rows="1"
                          class="mb-2"
                          :label="$translate('ACCOUNT_VAT_NUMBER')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{ $translate("PAYMENT_PLATFORM") }}</h4>
                        <v-select
                          :disabled="!partner.PaymentContract"
                          :rules="[paymentPlatformRule]"
                          v-model="partner.PaymentPlatform"
                          :items="paymentPlatforms"
                          :label="$translate('PAYMENT_PLATFORM')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{ $translate("ACCOUNT_HOLDER_NAME") }}</h4>
                        <v-text-field
                          v-model="partner.AccountHolderName"
                          rows="1"
                          class="mb-2"
                          :label="$translate('ACCOUNT_HOLDER_NAME')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <h4>
                          {{ $translate("DIRECT_DEBIT_AUTHORISATION_DATE") }}
                        </h4>
                        <v-menu
                          ref="menu1"
                          :close-on-content-click="true"
                          v-model="menu1"
                          :nudge-right="40"
                          :return-value.sync="
                            partner.DirectDebitAuthorisationDateStr
                          "
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="formattedDirectDebitAuthorisationDate"
                            :label="
                              $translate('DIRECT_DEBIT_AUTHORISATION_DATE')
                            "
                            hide-details
                            append-icon="event"
                            readonly
                            ref="eventForm"
                            outline
                          ></v-text-field>
                          <v-date-picker
                            first-day-of-week="1"
                            color="primary"
                            v-model="partner.DirectDebitAuthorisationDateStr"
                            @input="
                              $refs.menu1.save(
                                partner.DirectDebitAuthorisationDateStr
                              )
                            "
                            no-title
                          />
                        </v-menu>
                      </v-flex>
                      <v-flex xs5>
                        <h4>{{ $translate("DIRECT_DEBIT_MANDATE_ID") }}</h4>
                        <v-text-field
                          v-model="partner.DirectDebitMandateId"
                          rows="1"
                          class="mb-2"
                          :label="$translate('DIRECT_DEBIT_MANDATE_ID')"
                          outline
                        />
                      </v-flex>
                      <v-flex
                        xs5
                        v-if="this.$store.getters['auth/userLevel'] > 8"
                      >
                        <h4>{{ $translate("MIN_MONTHLY_FEE") }}</h4>
                        <v-text-field
                          v-model="partner.MinMonthlyFee"
                          class="mb-2"
                          type="number"
                          :label="$translate('MIN_MONTHLY_FEE')"
                          outline
                        />
                      </v-flex>
                      <v-flex
                        xs5
                        v-if="this.$store.getters['auth/userLevel'] > 8"
                      >
                        <h4>
                          {{ $translate("SERVICE_ORDER_VALUE_THRESHOLD") }}
                        </h4>
                        <v-text-field
                          v-model="partner.ServiceOrderValueThreshold"
                          class="mb-2"
                          type="number"
                          :label="$translate('SERVICE_ORDER_VALUE_THRESHOLD')"
                          outline
                        />
                      </v-flex>
                      <v-flex xs5>
                        <v-checkbox
                          v-model="partner.PaymentContract"
                          :label="$translate('PAYMENT_CONTRACT')"
                          hide-details
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout class="mt-4" row wrap justify-space-around>
                <v-flex xs5>
                  <h4>{{ $translate("PARTNER_TYPE") }}</h4>
                  <v-select
                    v-model="partner.Type"
                    :items="partnerTypes"
                    :label="$translate('PARTNER_TYPE')"
                    outline
                  />
                </v-flex>
                <v-flex xs5>
                  <h4>{{ $translate("SERVICE_PRICE_PERCENTAGE") }}</h4>
                  <v-text-field
                    v-model.number="partner.ServicePrice"
                    rows="1"
                    auto-grow
                    class="mb-2"
                    :label="$translate('SERVICE_PRICE_PERCENTAGE')"
                    outline
                    type="number"
                    min="0"
                    max="100"
                    prefix="%"
                  />
                </v-flex>
                <v-flex xs5>
                  <h4>{{ $translate("ACCOUNT_CAMPAIGN_BUDGET") }}</h4>
                  <v-text-field
                    v-model.number="partner.CampaignBudget"
                    rows="1"
                    auto-grow
                    class="mb-2"
                    label="Campaign Budget"
                    outline
                    type="number"
                    min="0"
                    prefix="€"
                  />
                </v-flex>
                <v-flex xs5>
                  <h4>{{ $translate("SERVICE_MINIMUM_PRICE") }}</h4>
                  <v-text-field
                    v-model.number="partner.MinimumServicePrice"
                    rows="1"
                    auto-grow
                    class="mb-2"
                    :label="$translate('SERVICE_MINIMUM_PRICE')"
                    outline
                    type="number"
                    min="0"
                    prefix="€"
                  />
                </v-flex>

                <v-flex xs5>
                  <h4>{{ $translate("ACCOUNT_PARTNER_SUPPLIER_CODE") }}</h4>
                  <v-text-field
                    v-model.number="partner.SupplierCode"
                    rows="1"
                    class="mb-2"
                    :label="$translate('ACCOUNT_SUPPLIER_CODE')"
                    outline
                  />
                </v-flex>
              </v-layout>
              <v-layout row justify-space-around pb-3>
                <v-flex xs4>
                  <v-checkbox
                    v-model="partner.PlanningContract"
                    :label="$translate('PLANNING_CONTRACT')"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox
                    v-model="partner.Active"
                    :label="$translate('ACTIVE_PARTNER')"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout class="mt-4 pb-4" row wrap justify-space-between>
          <v-spacer></v-spacer>
          <v-flex class="pl-4 pr-4" xs2>
            <v-btn color="secondary" round block @click="close">{{
              $translate("CANCEL")
            }}</v-btn>
          </v-flex>
          <v-flex class="pl-4 pr-4" xs2>
            <v-btn
              color="primary"
              round
              block
              :loading="saveBtnLoading"
              @click="saveNewPartner"
              >{{ $translate("SAVE") }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-dialog v-model="doublePartnerDialog" persistent max-width="390">
      <v-card class="confirmLoadingDialog">
        <v-layout column justify-center align-start>
          <v-card-title class="headline">{{
            $translate("ERROR")
          }}</v-card-title>
          <v-card-text>
            <p>{{ $translate("DUPLICATEDPARTNERNAME_ERROR") }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-flex>
              <v-btn
                round
                color="primary"
                @click="doublePartnerDialog = false"
                >{{ $translate("CANCEL") }}</v-btn
              >
            </v-flex>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import LoginPopup from "@/components/LoginPopup";
import { ui_helpers } from "@/shared/ui_helpers";
import * as dssRequest from "@/api/dssRequest";
import PartnerObject from "@/objects/PartnerObject";
import _ from "lodash";
import * as validationRules from "@/shared/validations_rules";
import BaseComponent from "../base/BaseComponent.vue";
import { store } from "../../store";

export default {
  extends: BaseComponent,
  name: "AccountPartners",
  mixins: [ui_helpers],
  components: {
    LoginPopup
  },
  computed: {
    formTitle() {
      return this.editMode ? `Details of ${this.partner.Name}` : "New Partner";
    },
    formattedDirectDebitAuthorisationDate() {
      return this.formatDate(this.partner.DirectDebitAuthorisationDateStr);
    }
  },
  data() {
    return {
      partnerLevels: [
        {
          Level: 0,
          Name: "Unregistered"
        },
        {
          Level: 1,
          Name: "Registered"
        },
        {
          Level: 2,
          Name: "Basic"
        },
        {
          Level: 3,
          Name: "Premium"
        }
      ],

      userGroupsSelectedForUser: [],
      userGroupsAvailableForUser: [],

      doublePartnerDialog: false,
      partnerFormValid: false,
      deleteDisable: false,
      dialogDelete: false,
      editMode: false,
      partnerDetailsDialog: false,

      partners: [],
      partner: PartnerObject._objectDefinition(),
      partnerTypes: ["Small", "Medium", "Large"],
      paymentPlatforms: ["Mollie", "Global Ticket"],

      // Rules of the Partner form
      textRules: validationRules.optionalTextRulesTo32,
      partnerNameRule: [v => !!v || "A name for the partner is required"],
      partnerEmailRule: validationRules.emailRules,

      // Headers of the Partner table
      headers: [
        {
          text: this.$translate("PARTNER_NAME"),
          align: "left",
          sortable: true,
          value: "Name"
        },
        {
          text: this.$translate("PARTNER_EMAIL"),
          align: "left",
          sortable: true,
          value: "Email"
        },
        {
          text: this.$translate("PARTNER_TYPE"),
          align: "left",
          sortable: true,
          value: "Type"
        },
        {
          text: this.$translate("PLANNING_CONTRACT"),
          align: "left",
          sortable: true,
          value: "PlanningContract"
        },
        {
          text: this.$translate("PAYMENT_CONTRACT"),
          align: "left",
          sortable: true,
          value: "PaymentContract"
        },
        {
          text: this.$translate("PAR_CON_STATUS"),
          align: "center",
          sortable: true,
          value: "Active"
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: ""
        }
      ],
      menu1: "",
      saveBtnLoading: false
    };
  },
  mounted() {
    this.getPartners();
  },
  methods: {
    switchToPartnerAdmin(partnerData) {
      console.log(
        "Going to switch to partner admin with partnerData: ",
        partnerData
      );
      store.commit("auth/setUserLevel", 6); // Partner admin
      store.commit("auth/setPartnerId", partnerData.PartnerId);
      store.commit("auth/setTmpPartnerAdmin", true);

      const payload = {
        FunctionId: "UserFunctionLibrary::switchUserLevel",
        PartnerId: this.$store.getters["auth/partnerId"]
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call switchUserLevel was successful",
            response
          );
          location.reload();
        },
        error => {
          console.log(
            "The generic call switchUserLevel was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        store.getters.getCurrentAccountId,
        payload
      );
    },
    getPartners() {
      // Action for loading all the Partners in the current account
      const payload = {
        FunctionId: "AccountFunctionLibrary::getPartners"
      };
      dssRequest.doRequest(
        response => {
          console.log("the call for getPartners was successful", response);
          // Clear the current partners array
          this.partners = [];
          // Insert PartnerId to each partner object
          for (const [k, v] of Object.entries(response.data.Partners)) {
            if (!v.ExternalEventBridges.hasOwnProperty("Formitable")) {
              v.ExternalEventBridges.Formitable = {
                ApiKey: ""
              };
            }
            if (!v.ExternalEventBridges.hasOwnProperty("TicketCounter")) {
              v.ExternalEventBridges.TicketCounter = {
                ClientId: "",
                ClientSecret: "",
                Username: "",
                Password: "",
                RefreshToken: ""
              };
            }
            if (v.DirectDebitAuthorisationDate !== 0) {
              const directDebitAuthorisationDate = new Date(
                v.DirectDebitAuthorisationDate * 1000
              );
              v.DirectDebitAuthorisationDateStr = `${directDebitAuthorisationDate.getFullYear()}-${directDebitAuthorisationDate.getMonth() +
                1}-${directDebitAuthorisationDate.getDate()}`;
            } else {
              v.DirectDebitAuthorisationDateStr = "";
            }
            this.partners.push({ PartnerId: Number(k), ...v });
          }
        },
        error => {
          console.log("the call for getPartners was not successful", error);
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );
    },
    close() {
      this.partnerDetailsDialog = false;
    },
    newItem() {
      // Action for clicking on the plus button in the Partner screen
      this.partner = PartnerObject._objectDefinition();
      this.$refs.partnerForm.resetValidation();
      this.editMode = false;
      this.partnerDetailsDialog = true;
    },
    editItem(item) {
      console.log("Lorenzo item", item);
      // Action for clicking on the edit button in the Partner screen
      this.partner = { ...item };
      this.editMode = true;
      this.partnerDetailsDialog = true;
    },
    deleteItem(item) {
      // Action for clicking on the delete button in the Partner screen
      this.partner = { ...item };
      this.dialogDelete = true;
    },
    formatDate(date) {
      if (date == null || typeof date !== "string" || date.trim() === "")
        return "";

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    saveNewPartner() {
      // Action for clicking on the SAVE button in the Partner details dialog
      if (this.$refs.partnerForm.validate()) {
        this.saveBtnLoading = true;

        if (!this.partner.SupplierCode) {
          this.partner.SupplierCode = "";
        }

        if (!this.partner.VatNumber) {
          this.partner.VatNumber = "";
        }

        if (!this.partner.COC) {
          this.partner.COC = "";
        }

        if (!this.partner.NoReplyEmailAddress) {
          this.partner.NoReplyEmailAddress = "";
        }

        if (this.partner.DirectDebitAuthorisationDateStr !== "") {
          console.log(
            "Lorenzo date",
            this.partner.DirectDebitAuthorisationDateStr
          );
          this.partner.DirectDebitAuthorisationDate =
            new Date(this.partner.DirectDebitAuthorisationDateStr).getTime() /
            1000;
        } else {
          this.partner.DirectDebitAuthorisationDate = 0;
        }

        const payload = { ...this.partner };
        const requestId = this.editMode ? "editPartner" : "createPartner";

        dssRequest.doRequest(
          response => {
            console.log(`the call for ${requestId} was successful`, response);

            this.saveBtnLoading = false;

            // this.partner.PartnerId = Number(response.data.PartnerId);
            this.close();
            this.getPartners();
          },
          error => {
            console.log(`the call for ${requestId} was not successful`, error);

            this.saveBtnLoading = false;

            if (
              error.hasOwnProperty("errorMsg") &&
              error.errorMsg.includes("E_OB_033")
            ) {
              this.doublePartnerDialog = true;
            }
          },
          requestId,
          this.currentAccountId,
          payload,
          600000,
          false
        );
      }
    },
    deletePartner() {
      // Action for clicking on the DELETE button in the delete dialog
      const payload = {
        PartnerId: this.partner.PartnerId
      };
      dssRequest.doRequest(
        response => {
          console.log("the call for deletePartner was successful", response);
          this.dialogDelete = false;
          this.getPartners();
        },
        error => {
          console.log("the call for deletePartner was not successful", error);
        },
        "deletePartner",
        this.currentAccountId,
        payload
      );
    },
    paymentPlatformRule(v) {
      if (v) {
        return true;
      }
      if (!this.partner.PaymentContract) {
        return true;
      }
      return "A payment platform for the partner is required";
    }
  }
};
</script>

<style>
.blockForInputfields {
  padding: 1em;
}
</style>
